export default __webpack_public_path__ + "static/devops1-c80017f1028e967d9d683b01b2d8b1eb.png";